import React from 'react'
import { useNavigate } from 'react-router-dom';

import classes from './../Onboarding.module.scss';
import UpperDiv from './UpperDiv';
import LowerDiv from './LowerDiv';
import change_pic_1 from './../../../assets/onboarding/change_pic_1.svg'
import change_pic_2 from './../../../assets/onboarding/change_pic_2.svg'
import change_pic_3 from './../../../assets/onboarding/change_pic_3.svg'
import change_pic_4 from './../../../assets/onboarding/change_pic_4.svg'
import Pagination from './Pagination';

const upperDivStyle = {
  display: "flex",
  alignItems: 'flex-end',
  justifyContent: 'center',
  flexDirection: 'column'
}

const lowerDivStyle = {
  display: "flex",
  flexDirection: 'column',
  gap: '0'
}

const change_pic_1_style = {
  position: "absolute",
  maxWidth: '90%',
  top: 10
}

const change_pic_2_style = {
  position: "absolute",
  maxWidth: '90%',
  left: 10,
  marginTop: 90,
  zIndex: 99
}

const change_pic_3_style = {
  position: "absolute",
  right: 10,
  bottom: -120,
  maxWidth: '90%',
  zIndex: 99
}


const change_pic_4_style = {
  marginLeft: "-20px",
  maxWidth: '25%',
}

const Page3 = () => {
  const navigate = useNavigate();

  return (
    <>
      <UpperDiv style={upperDivStyle}>
        <img src={change_pic_1} alt="" style={change_pic_1_style} />
        <img src={change_pic_2} alt="" style={change_pic_2_style} />
        <img src={change_pic_3} alt="" style={change_pic_3_style} />
      </UpperDiv>
      <LowerDiv style={lowerDivStyle}>
        <div className={classes.Page2Div}>
          <img src={change_pic_4} alt="" style={change_pic_4_style} />
          <h3 className={classes.Page2H3}>
            Register Face
          </h3>
          <p className={classes.NameH3}>
            Register Your Facial data using the
            Change Pic Button
          </p>
        </div>
        <div className={classes.Page2Pagination}>
        <div style={{ display: 'flex' , width:"100%"}}>
            <button onClick={() => { navigate('/onboarding/2') }}>
              PREV
            </button>
            <button onClick={() => { navigate('/onboarding/4') }}>
              NEXT
            </button>
          </div>
          <Pagination numberOfDots={7} activePage={3} />
        </div>
      </LowerDiv>
    </>
  )
}

export default Page3